export function initMenuTabs() {

    document.querySelector('.menu-buttons span').addEventListener('keyup', function (event) {
        if (event.key === 'Tab') {// or event.keyCode === 9
            $('.tabs-slider .tab-menu ').removeClass('focus')
        }
    })

    $('.page-template-page-our-menu-new .tabs-slider .tab-menu').each(function () {
        var _id = $(this).attr('id')
        var _name = $(this).attr('data-name')
        document.querySelector('#' + _id).addEventListener('keyup', function (event) {

        if ( event.key === 'Enter' ) {// or event.keyCode === 13
            event.preventDefault()
            
            $('li[aria-controls="' + _name + '-1"]').attr( 'aria-selected', 'true' )    
            $('section[data-location="' + _name + '"] .tabs-slider button').attr('tabindex', '0')
            $(this).attr('tabindex', '-1')
            $('.tabs-slider .tab-menu').removeClass('focus')
            $(this).addClass('focus')
            $('section[data-location="' + _name + '"] address a').focus()
        }

        if ( event.key === 'Tab' ) {// or event.keyCode === 9
                event.preventDefault()
                $('.tabs-slider .tab-menu ').removeClass('focus')
                $(this).addClass('focus').focus()
            }
        })
    })

}


// WEBPACK FOOTER //
// ./assets/js/modules/menu-section-tabs.js